export default [
    { 
        title: "ZERO DASHBOARD",
        desc:"A dashboard is a type of graphical user interface which often provides at-a-glance views of key performance indicators relevant to a particular objective or business process.  ",
        tag:["mern","tailwindcss","bootstrap"],
        btn1:"https://github.com/reerajput930/zero-dashboard",
        btn2:"https://zero-dashboard.netlify.app/"

    },
    {
        title:"GROWTH APPLICATION",
        desc:"This app is made for two individuals. Both of them can check their Progress report and grow together to achieve their goals. It include ToDo manager and zira dashboard feature. ",
        tag:["mern","tailwind"],
        btn1:"https://github.com/reerajput930/growth-app",
        btn2:"https://github.com/reerajput930/growth-app"

    },
    {
        title:"EXPLODING KITTEN CARD GAME",
        desc:"Is a card web game, with some set of rules.",
        tag:["mern"],
        btn1:"https://github.com/reerajput930/Exploding-Kitten-",
        btn2:"https://github.com/reerajput930/growth-app"

    },
    {
        title:"CRUD OPERATIONS",
        desc:"Practice CRUD operations.(get,put,delete and post in server and used fetch in client side)",
        tag:["mern"],
        btn1:"https://github.com/reerajput930/CRUD-operations",
        btn2:"https://github.com/reerajput930/CRUD-operations"

    },
    {
        title:"GITHUB FOLLOWERS API",
        desc:"It fetches the Github follower via API and displays it on the browser.",
        tag:["reactjs"],
        btn1:"https://github.com/reerajput930/Github-followers-api",
        btn2:"https://pagination-filteration.netlify.app/"

    },
    {
        title:"PORTFOLIO",
        desc:"My personal Portfolio.",
        tag:["reactjs","chatGPT","html","css"],
        btn1:"https://github.com/reerajput930/personal-portfolio",
        btn2:"https://ree-portfolio.netlify.app/"

    },
    {
        title:"KFC MENU",
        desc:" ",
        tag:["reactjs","html","css"],
        btn1:"https://github.com/reerajput930/kfc-menu",
        btn2:"https://reerajput930.github.io/kfc-menu/"

    },
    {
        title:"CUSTOMER REVIEW SLIDER",
        desc:"customer review slider.",
        tag:["reactjs","html","css"],
        btn1:"https://github.com/reerajput930/customer-reviews-slider",
        btn2:"https://reerajput930.github.io/customer-reviews-slider/"

    },
    {
        title:"BIRTHDAY REMINDER",
        desc:" ",
        tag:["reactjs","html","css"],
        btn1:"https://github.com/reerajput930/birthday-reminder/tree/gh-pages",
        btn2:"https://reerajput930.github.io/birthday-reminder/"

    },
    {
        title:"TextUtils",
        desc:" ",
        tag:["reactjs","js","html","css"],
        btn1:"https://github.com/reerajput930/TextUtils-React",
        btn2:"https://reerajput930.github.io/TextUtils-React/"

    },
    {
        title:"CLASSIC TO DO LIST",
        desc:"This is used as a daily task reminder, used localstorage for storing the data, used js and html/css for it's creation.",
        tag:["js","html","css"],
        btn1:"https://github.com/reerajput930/to-do-list",
        btn2:" https://reerajput930.github.io/to-do-list/"

    },
    {
        title:"SERVICE WEBSITE",
        desc:"This is a Demo service website.",
        tag:["html","css"],
        btn1:"https://github.com/reerajput930/resposive-service-website",
        btn2:"https://reerajput930.github.io/resposive-service-website/"

    },
    {
        title:"FRIENDS SITCOM QUIZ",
        desc:"Quiz based on the popular sitcom, friends.",
        tag:["js","html","css",],
        btn1:"https://github.com/reerajput930/friends_quiz",
        btn2:"https://reerajput930.github.io/friends_quiz/"

    },
    {
        title:"GYM SERVICE WEBSITE",
        desc:"Demo Gym service website",
        tag:["html","css"],
        btn1:"https://github.com/reerajput930/gym-service-websit",
        btn2:"https://reerajput930.github.io/gym-service-website/"

    },
    {
        title:"NEUMORPHIC DESIGN LOGIN PAGE",
        desc:" ",
        tag:["html","css"],
        btn1:"https://github.com/reerajput930/neumorphic-design-Login-page-",
        btn2:"https://github.com/reerajput930/neumorphic-design-Login-page-"

    },
    
]